module.exports = __webpack_public_path__ + "static/media/jam_triangle-danger.54597f60.svg";